import fetchIssue from './get-issue/get-issue-service';
import fetchIssuesFilters from './get-issues-filters/get-issues-filters-service';
import fetchIssues from './get-issues/get-issues-service';
import addCommentToIssue from './add-comment-to-issue/add-comment-to-issue';
import addPolicyFix from './add-policy-fix/add-policy-fix-service';
import { pullRequestClient, reportClient } from '../../../api/clients';
import getExportedIssues from './get-exported-issues/get-exported-issues';

const issuesService = {
  getIssues: fetchIssues(reportClient),
  getIssue: fetchIssue(reportClient),
  getExportedIssues: getExportedIssues(reportClient),
  getIssuesFilters: fetchIssuesFilters(reportClient),
  addCommentToIssue: addCommentToIssue(reportClient),
  addPolicyFix: addPolicyFix(pullRequestClient),
};

export default issuesService;
